import {
  CustomersState,
  IBlock,
  IPurchaseReceiver,
  ICustomer,
  Types,
  ECreditRenewStatus,
  IProductDescriptionResponse
} from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: CustomersState = {
  customers: [],
  loading: false,
  error: false,
  loadingCustomerById: false
};

type CustomAction = {
  type: Types;
  payload: {
    customers: ICustomer[];

    selectedCustomerId: string;
    customer: ICustomer;

    productsDescriptionResponse: IProductDescriptionResponse;
    customerBlocks: IBlock[];

    receivers: IPurchaseReceiver[];
    creditRenewCode: string;
    creditRenewRequestId: string;
    creditRenewRequestStatus: ECreditRenewStatus;
  };
};

const reducer: Reducer<CustomersState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_CUSTOMERS:
      return { ...state, customers: [], loading: true, error: false };
    case Types.LOAD_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        loading: false,
        error: false,
        loadingCustomerById: false,
        initialized: true
      };
    case Types.LOAD_CUSTOMERS_FAILURE:
      return { ...state, loading: false, error: true };

    case Types.LOAD_CUSTOMER_BY_ID:
      return {
        ...state,
        loadingCustomerById: true,
        error: false,
        errorBp: false
      };
    case Types.LOAD_CUSTOMER_BY_ID_SUCCESS:
      return {
        ...state,
        customers: setLoadedCustomerInCustomersList(
          action.payload.customer,
          state.customers
        ),
        loadingCustomerById: false
      };
    case Types.LOAD_CUSTOMER_BY_ID_FAILURE:
      return { ...state, loadingCustomerById: false, errorBp: true };

    case Types.SET_CREDIT_RENEW_CODE:
      return {
        ...state,
        customers: setCreditRenewCode(
          state.customers,
          action.payload.selectedCustomerId,
          action.payload.creditRenewCode,
          action.payload.creditRenewRequestId,
          action.payload.creditRenewRequestStatus
        )
      };

    // productDescription
    case Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION:
      return {
        ...state,
        loadingProductDescription: true,
        errorProductDescription: false
      };
    case Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_SUCCESS:
      return {
        ...state,
        customers: setProductDescriptionInCustomer(
          state.customers,
          action.payload.productsDescriptionResponse,
          action.payload.selectedCustomerId
        ),
        loadingProductDescription: false,
        errorProductDescription: false
      };
    case Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingProductDescription: false,
        errorProductDescription: true
      };

    case Types.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_V2:
      return {
        ...state,
        loadingProductDescription: true,
        errorProductDescription: false
      };

    // blocks
    case Types.LOAD_CUSTOMER_BLOCKS:
      return { ...state, loadingBlocks: true, errorBlocks: false };
    case Types.LOAD_CUSTOMER_BLOCKS_SUCCESS:
      return {
        ...state,
        customers: setBlocksInCustomer(
          state.customers,
          action.payload.customerBlocks,
          action.payload.selectedCustomerId
        ),
        loadingBlocks: false,
        errorBlocks: false
      };
    case Types.LOAD_CUSTOMER_BLOCKS_FAILURE:
      return { ...state, loadingBlocks: false, errorBlocks: true };

    // receivers
    case Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS:
      return {
        ...state,
        loadingPurchaseReceivers: true,
        errorPurchaseReceivers: false
      };
    case Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS_SUCCESS:
      return {
        ...state,
        loadingPurchaseReceivers: false,
        errorPurchaseReceivers: false,
        customers: setReceiversInCustomer(
          state.customers,
          action.payload.selectedCustomerId,
          action.payload.receivers
        )
      };
    case Types.LOAD_CUSTOMER_PURCHASE_RECEIVERS_FAILURE:
      return {
        ...state,
        loadingPurchaseReceivers: false,
        errorPurchaseReceivers: true
      };

    case Types.CLEAN_ERRORS:
      return {
        ...state,
        errorBlocks: false,
        errorProductDescription: false,
        errorPurchaseReceivers: false
      };

    default:
      return state;
  }
};

const setBlocksInCustomer = (
  customers: ICustomer[],
  blocks: IBlock[],
  selectedCustomerId: string
): ICustomer[] => {
  const customer = customers.find(
    (c) => c.customerId === selectedCustomerId
  ) as ICustomer;
  customer.blocks = blocks;
  return customers;
};

const setProductDescriptionInCustomer = (
  customers: ICustomer[],
  productsDescriptionResponse: IProductDescriptionResponse,
  selectedCustomerId: string
): ICustomer[] => {
  const customer = customers.find(
    (c) => c.customerId === selectedCustomerId
  ) as ICustomer;
  customer.productsDescriptionResponse = productsDescriptionResponse;
  return customers;
};

const setReceiversInCustomer = (
  customers: ICustomer[],
  selectedCustomerId: string,
  receivers: IPurchaseReceiver[]
): ICustomer[] => {
  const customer = customers.find(
    (c) => c.customerId === selectedCustomerId
  ) as ICustomer;
  customer.purchaseReceivers = receivers;
  return customers;
};

const setCreditRenewCode = (
  customers: ICustomer[],
  customerId: string,
  creditRenewCode: string,
  creditRenewRequestId: string,
  creditRenewRequestStatus: ECreditRenewStatus
): ICustomer[] => {
  const customerIdx = customers.findIndex(
    (cust) => cust.customerId === customerId
  );
  if (customerIdx !== -1) {
    customers[customerIdx] = {
      ...customers[customerIdx],
      creditRenew: true,
      creditRenewCode,
      creditRenewRequestId,
      creditRenewRequestStatus
    };
  }
  return customers;
};

const setLoadedCustomerInCustomersList = (
  customer: ICustomer,
  customerList: ICustomer[]
): ICustomer[] => {
  const idx = customerList.findIndex(
    (cust) => cust.customerId === customer.customerId
  );

  if (idx === -1) {
    customerList.push(customer);
  } else {
    customerList[idx] = customer;
  }
  return customerList;
};

export default reducer;
